import styled, { keyframes, ThemeProvider } from 'styled-components'

import gameDayG from '../../images/gameDayG.svg'
import theme from '../../utils/theme'

const CircleKeyFrames = keyframes`
  0% {transform: scale(1)}
  10% {transform: scale(0.7)}
  20% {transform: scale(1)}
  40% {transform: scale(1)}
  50% {transform: scale(0.7)}
  60% {transform: scale(1); opacity: 0}
  80% {opacity: 1}
`

const GKeyFrames = keyframes`
  10% {transform: scale(1)}
  20% {transform: scale(1)}
  30% {transform: scale(0.7)}
  40% {transform: scale(1)}
  100% {transform: scale(1)}
`

const LoadingBackground = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 50%;
  animation: ${CircleKeyFrames} 2s ease-in-out 0s infinite;
`

const LoadingImage = styled.img`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  animation: ${GKeyFrames} 2s ease-in-out 0s infinite;
`

const LoadingLogo = ({ size }) => (
  <ThemeProvider theme={theme}>
    <LoadingBackground size={size}>
      <LoadingImage size={size} src={gameDayG} />
    </LoadingBackground>
  </ThemeProvider>
)

LoadingLogo.defaultProps = {
  size: 16,
}

export default LoadingLogo
